import {
  createRootRouteWithContext,
  createRoute,
  createRouter,
  Outlet,
  redirect,
} from '@tanstack/react-router';
import type { useAuth } from './auth';
import { ChatPage, NewChatPage } from './pages/Chat';
import { LoginPage } from './pages/Login';
import { ThreadsLayout } from './pages/Threads';

export interface RouterContext {
  auth: ReturnType<typeof useAuth>;
}

const rootRoute = createRootRouteWithContext<RouterContext>()({ component: Outlet });

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  beforeLoad: ({ context }) => {
    if (context.auth.session) throw redirect({ to: '/' });
  },
  component: LoginPage,
});

const appRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'app',
  beforeLoad: ({ context }) => {
    if (!context.auth.session) throw redirect({ to: '/login' });
  },
  component: ThreadsLayout,
});

// FarmAI opens on a new chat; the list is /chats (beside the chat on wide screens)
const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/',
  component: NewChatPage,
});
const chatsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/chats',
  component: NewChatPage,
});

const threadRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/t/$threadId',
  component: ChatPage,
});

export const router = createRouter({
  routeTree: rootRoute.addChildren([
    loginRoute,
    appRoute.addChildren([indexRoute, chatsRoute, threadRoute]),
  ]),
  context: { auth: undefined! },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
